var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-0 px-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"fill-height",attrs:{"no-gutters":""}},[[_c('v-scroll-x-transition',{attrs:{"mode":"out-in","hide-on-leave":""}},[_c('router-view')],1)]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }